<div id="buildyourown" class="container col-12" *ngIf="updatePlanData">
  <div class="row d-flex align-items-center justify-content-between mb-12">
    <div class="p-0 col-md-6 col-lg-6">
      <span class="p-1 gb-body1 heavy">{{ updatePlanData.byoCopy.copy }} </span>
    </div>
    <div class="d-flex align-items-center justify-content-between ml-auto">
      <span
        class="p-0 firstlet-cap gb-body3 medium-screen-custom-order-right mr-1"
        >{{ updatePlanData.offers[0].prices[0].discountCopy }}
      </span>
      <div
        class="cit2-badge-discount mt-1"
        *ngIf="updatePlanData.offers[0].prices[0].discountPercentage"
      >
        <span aria-hidden="true" class="icon-ui-offer-tag"></span>
        <div class="gb-body2 heavy">
          <p class="mb-0">
            {{ updatePlanData.offers[0].prices[0].discountPercentage }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div *ngFor="let product of byoProducts; let i = index">
    <div class="row mb-8" *ngIf="product.price">
      <div class="col-12 p-0">
        <div class="card-byo-cit2 selected">
          <div class="selectedlabel" *ngIf="product.selected">
            <span class="selectedicon float-left">
              <h6 class="selectedtext">
                {{ updatePlanData.byoCopy.selected.label }}
              </h6>
              <span class="btn-icn icon-dummy_profile btn-acc btn-log">
                <span aria-hidden="true" class="icon-ui-check icon-check"></span
              ></span>
            </span>
          </div>
          <div class="d-flex flex-column">
            <div class="row">
              <div class="col-12 col-lg-4 mb-8 mb-lg-0">
                <span
                  class="firstlet-cap gb-body2 pb-6"
                  *ngIf="isMyCurrentPlan(product.code)"
                >
                  {{ getCopy('eyebrow.my.current.plan.copy') }}</span
                >
                <div
                  class="gb-body2 mb-3"
                  *ngIf="isIncludedInCurrentPlan(product.code)"
                >
                  {{ updatePlanData.byoCopy.selected.eyebrowText }}
                </div>
                <div class="gb-body1 heavy mb-3">
                  {{
                    product.multiCardDisplayName || product.displayName
                  }}
                </div>
                <div class="gb-body2 mb-0">
                  <p class="mb-0">
                    {{
                      replaceBrand(
                        product.description,
                        (activeVehicle$ | async)?.make
                      )
                    }}
                  </p>
                </div>
              </div>

              <div class="col-12 col-lg-4 mb-6 mb-lg-0">
                <ul class="category">
                  <li
                    *ngFor="
                      let featureValue of product.features;
                      let fi = index
                    "
                  >
                    <div class="gb-body2 d-flex align-self-center flex-nowrap">
                      <div class="col-10 p-0">
                        <a
                          (click)="
                            trackProductClickEvent(product, featureValue, 'button', 'description');
                            openServiceModal(product, featureValue)
                          "
                          role="button"
                        >
                          {{
                            replaceBrand(
                              featureValue.name,
                              (activeVehicle$ | async)?.make
                            )
                          }}
                           <span aria-hidden="true" class="icon-ui-arrowright right-arrow"></span>
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div
                class="col-12 col-lg-4"
                *ngIf="isCompositeProduct(product.code)"
              >
                <div class="row mb-1 toggle mt-5">
                  <div class="container ng-scope" style="padding-left: 0px">
                    <div
                      class="btn-group btn-group-toggle"
                      data-toggle="buttons"
                      *ngIf="product.offers.length > 1"
                    >
                      <label
                        *ngFor="let item of product.offers; index as index"
                        id="label-option{{ index }}"
                        class="btn gb-secondary-button border-gray"
                        [ngClass]="{
                          active: product.selectedOfferIndex === index
                        }"
                        (click)="setValue(i, product, index, true)"
                        (keyup.enter)="setValue(i, product, index, true)"
                        tabindex="0"
                      >
                        <input
                          type="radio"
                          name="options"
                          id="input-option{{ index }}"
                          tabindex="-1"
                          autocomplete="off"
                          [checked]="0"
                        />
                        <div id="div-option{{ index }}">
                          {{ item.planId }}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="gb-body3 mb-2">
                  {{
                    updatePlanData.byoCopy.selected
                      .bundledProductPriceCopyPrefix
                  }}
                </div>
                <div class="gb-body1 heavy mb-2 d-inline-block">
                  {{ lastEmitObject.selectedProductPrice | currency }}
                  {{ lastEmitObject.product?.code }}
                  {{
                    updatePlanData.byoCopy.selected
                      .bundledProductPriceCopySuffix
                  }}
                </div>
                <div class="gb-body3 d-inline-block">
                  {{
                    updatePlanData.byoCopy.selected.compositeProductPriceCopy
                  }}
                  {{ product.price.customerFinalPrice | currency }}
                </div>
                <div class="gb-body3 d-inline-block">
                  {{ product?.price?.billingFrequencyCopy }}
                </div>
                <button
                  (click)="
                  generateAnalyticsInfo(i, product);
                    addOrRemove(i)
                  "
                  class="col-12 p-1 firstlet-cap gb-primary-button mt-4"
                  data-toggle="modal"
                >
                  {{ addOrRemoveText(product) }}
                </button>
              </div>

              <div
                class="col-12 col-lg-4"
                *ngIf="!isCompositeProduct(product.code)"
              >
                <div class="row mb-1 toggle mt-5">
                  <div class="container ng-scope" style="padding-left: 0px">
                    <div
                      class="btn-group btn-group-toggle"
                      data-toggle="buttons"
                      *ngIf="product.offers.length > 1"
                    >
                      <label
                        *ngFor="let item of product.offers; index as index"
                        id="label-option{{ index }}"
                        class="btn gb-secondary-button border-gray"
                        [ngClass]="{
                          active: product.selectedOfferIndex === index
                        }"
                        (click)="
                          setValue(i, product, index, true);
                          trackProductClickEvent(product, item, 'toggle', item.planId)
                        "
                        (keyup.enter)="setValue(i, product, index, true)"
                        tabindex="0"
                      >
                        <input
                          type="radio"
                          name="options"
                          id="input-option{{ index }}"
                          tabindex="-1"
                          autocomplete="off"
                          [checked]="0"
                        />
                        <div id="div-option{{ index }}">
                          {{ item.planId }}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="gb-body1 heavy d-inline-block">
                  {{ product.price.customerFinalPrice | currency }}
                </div>
                <div
                  class="gb-body2 strike-through d-inline-block"
                  *ngIf="
                    product.price?.customerFinalPrice !==
                    product.price?.retailPrice
                  "
                >
                  {{ product.price.retailPrice | currency }}
                </div>
                <div class="gb-body3 d-inline-block">
                  {{ product.price.billingFrequencyCopy }}
                </div>
                <button
                  (click)="
                  generateAnalyticsInfo(i, product);
                    addOrRemove(i)
                  "
                  class="col-12 p-1 firstlet-cap gb-primary-button mt-4"
                  data-toggle="modal"
                >
                  {{ addOrRemoveText(product) }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>